import { Visualizer, VisualizerControl, VisualizationUpdateLevel } from '../data-source/visualizer';
import { Timeline } from '../timeline/timeline';
import { Map } from '../map/map';
import { ModelingContainer, ModelingVisualizerControl } from './container-modeling';
import { InspectionPanel } from '../panel/panel';
import { Drawer } from '../panel/cabinets';
import { WindFieldLayer, WindProfileInterval } from '@mapp/r-mapp-lib';
import WindFieldWorker from 'worker-loader!../wind-field/wind-field-worker';
import { ModelingDataSource } from './modeling';

export class WindFieldMapVisualizer implements Visualizer {
	private controls: { [key: string]: VisualizerControl }
	private inspectionContainer: ModelingContainer
	private source: ModelingDataSource;

	private map: Map | undefined = undefined;;

	private windFieldWorker: Worker;
	private svelteWindFieldLayer: WindFieldLayer;

	public constructor(private visualizerKey: string, private mdlType: string, private drawer: Drawer) {
		this.inspectionContainer = <ModelingContainer>this.drawer.getContainer();
		this.source = this.inspectionContainer.getDataSource();
		const windFieldId = this.source.getWindFieldId(this.mdlType);
		if (windFieldId) {
			this.windFieldWorker = new WindFieldWorker();

			if (this.inspectionContainer.getContainerNode()) {
				if ((<InspectionPanel>this.inspectionContainer.getPanel()).getMapImplementationWrapper()) {
					const svelteWindFieldLayerArgument = {
						target: this.inspectionContainer.getContainerNode(),
						props: {
							worker: this.windFieldWorker,
							host: <string>undefined, //ussuming same host
							domain: encodeURI(this.inspectionContainer.getApplication().getDomain()),
							credentials: this.inspectionContainer.getApplication().getDigester().getCredentials(),
							legacyMapWrapper: (<InspectionPanel>this.inspectionContainer.getPanel()).getMapImplementationWrapper(),
							legacyMap: <google.maps.Map>undefined, //will be set by this viewers setMap
							hpc: windFieldId.hpc,//<string>undefined, //defined by the scalarfield manager
							model: windFieldId.model,//<string>undefined, //defined by the scalarfield manager
							profile: <WindProfileInterval[]>[],//defined by the scalarfield manager
							time: <number>undefined,//defined by time cursor
							legacyLogging: false, //is also the default, but kept for documentation
						}
					}

					this.svelteWindFieldLayer = new WindFieldLayer(svelteWindFieldLayerArgument);

					const updateWindFieldProfile = (profile: WindProfileInterval[]) => {
						this.svelteWindFieldLayer.$$set({
							profile,
						});
					}

					const updateWindField = (time: number | undefined) => {
						this.svelteWindFieldLayer.$$set({
							time,
						});
					}

					this.source.getScalarFieldManager(this.mdlType).setWindFieldConsumer(updateWindFieldProfile, updateWindField);
				}
			}
		}
	}

	public release(): void {
		if (this.inspectionContainer.getContainerNode() && this.svelteWindFieldLayer) {
			this.inspectionContainer.getContainerNode().removeChild(
				this.inspectionContainer.getContainerNode().querySelector('.wind-field-layer')
			);
			this.svelteWindFieldLayer = undefined;
		}
		if (this.windFieldWorker) {
			this.windFieldWorker.terminate();
			this.svelteWindFieldLayer = undefined;
		}
	}

	public updateSelection(): void {
		//not implemented here
	}

	public refresh(_level: VisualizationUpdateLevel): void {
		if (this.controls && this.controls[this.type()] && this.controls[this.type()].enabled(this.key())) {
			if (this.svelteWindFieldLayer) {
				if (!this.map) {
					this.map = this.source.getMap();
					this.svelteWindFieldLayer.$$set({
						legacyMap: this.map ? this.map.getGMap() : undefined,
					});
				}
			} else{
				this.controls[this.type()].setEnabled(this.key(),false);
			}
		} else {
				this.setMap(undefined);
		}

	}

	public setMap(map: Map): void {
		this.map = map;
		if (this.svelteWindFieldLayer) {
			this.svelteWindFieldLayer.$$set({
				legacyMap: map ? map.getGMap() : undefined,
			});
		}
	}

	public setTimeline(_timeline: Timeline): void {
		//we do not deal with the timeline here
	}

	public type(): string {
		return this.mdlType;
	}
	public key(): string {
		return this.visualizerKey;
		//		return this.visualizerKey + '_' + this.type();
	}

	public setControls(controls: { [key: string]: VisualizerControl }): Visualizer {
		this.controls = <{ [key: string]: ModelingVisualizerControl }>controls;
		return this;
	}
}
